import { render, staticRenderFns } from "./StudentCallDetails.vue?vue&type=template&id=86b1357e&"
import script from "./StudentCallDetails.vue?vue&type=script&lang=js&"
export * from "./StudentCallDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudentCallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports